var MenuMobile = {
    init:function(){
        console.log("MENU MOBILE INIT");
        $(".header .btn-container.mobile .btn-menu").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }
            MenuMobile.open_menu_mobile();
        });
        $(".header .btn-container.mobile .btn-close").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }
            MenuMobile.close_menu_mobile();
        })
        $(".menu-mobile .shadow").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }
            MenuMobile.close_menu_mobile();
        });

        $(".menu-mobile .menu-container.level-0 > .menu-item.menu-item-has-children > a").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }
            e.stopPropagation();
            e.preventDefault();
            MenuMobile.open_submenu_mobile($(this).parent());
        });
        $(".menu-mobile .menu-container.level-0 > .menu-item.menu-item-has-children > span").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }
            e.stopPropagation();
            e.preventDefault();
            MenuMobile.open_submenu_mobile($(this).parent());
        });
        $(".menu-mobile .title-parent").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }
            e.stopPropagation();
            e.preventDefault();
            MenuMobile.close_submenu_mobile();
        });
        $(window).resize(function(){
            MenuMobile.resize();
        })
    },
    open_submenu_mobile:function(target){
        $(".menu-mobile").addClass("submenu-open");
        target.find(".menu-container.level-1").addClass("open");
    },
    close_submenu_mobile:function(){
        $(".menu-mobile").removeClass("submenu-open");
        $(".menu-mobile .menu-container.level-1").removeClass("open");
    },
    open_menu_mobile:function(){
        console.log("OPEN MENU MOBILE");

        $(".header").addClass("menu-mobile-open");
        $(".menu-mobile").addClass("open");
        $("body").addClass("no-scroll");
    },
    close_menu_mobile:function(){
        console.log("CLOSE MENU MOBILE");
        $(".header").removeClass("menu-mobile-open");
        $(".menu-mobile").removeClass("open");
        $("body").removeClass("no-scroll");
    },
    resize:function(){
        if($(".header").hasClass("menu-mobile-open")){
            MenuMobile.close_menu_mobile();
        }
    }

}

$(window).load(function(){
    setTimeout(function(){
        MenuMobile.init();
    }, 200);
})